import Axios from './interceptors'


// 获取文章列表
export function RemovePruchaseToDo(data) {
  return Axios({
    url: 'CommonModule/Op_Supplier/RemovePruchaseToDo',
    method: 'post',
    data
  })
}
// 获取上传文件类型
export function GetFileType(data) {
  return Axios({
    url: 'CommonModule/Op_Supplier/GetFileType',
    method: 'post',
    data:data
  })
}
// 获取上传文件类型
export function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}
